import { useEffect, useState, memo } from "react";

import { Props } from "./interfaces";
import { Button, Popover } from "./styles";

const SimplePopover = ({
  buttonType,
  buttonContent,
  buttonVariant,
  anchorOrigin = { vertical: "center", horizontal: "right" },
  transformOrigin = { vertical: "top", horizontal: "left" },
  shouldClose,
  flow,
  children,
  customButtonStyle,
  onOpen,
  buttonDisabled,
  buttonTitle,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: any) => {
    event.stopPropagation();
    // event.preventDefault();

    setAnchorEl(event.currentTarget);
    onOpen && onOpen();
  };

  const open = Boolean(anchorEl);

  useEffect(() => {
    if (shouldClose) setAnchorEl(null);
  }, [shouldClose]);

  return (
    <>
      <Button
        variant={buttonVariant}
        onClick={(event) => {
          event.stopPropagation();
          handleClick(event);
        }}
        isIcon={buttonType === "icon"}
        style={{ ...customButtonStyle }}
        disabled={buttonDisabled}
      >
        {buttonContent}
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClick={(event) => {
          event.stopPropagation();
          shouldClose && setAnchorEl(null);
        }}
        flow={flow}
        PaperProps={{
          sx: {
            padding: "10px",
          },
        }}
      >
        {children}
      </Popover>
    </>
  );
};

export default memo(SimplePopover);
